import { createFileRoute } from "@tanstack/react-router";
import { GemPage } from "@/pages/GemPage";

export const Route = createFileRoute("/gem")({
  component: GemRoute,
  head: () => ({
    meta: [
      {
        title: "Why the fascination with gemstones? - Tony Narlock",
      },
    ],
  }),
});

function GemRoute() {
  return <GemPage />;
}
